import { Inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

//"TE"testowe/"TR"demo/"PR"produkcja
export enum ApplicationMode {
  local = 'local',
  DV = 'DV',
  DE = 'DE',
  TI = 'TI',
  TE = 'TE', //testowe
  TX = 'TX',
  TY = 'TY',
  TZ = 'TZ',
  PP = 'PP',
  TR = 'TR', //demo
  PR = 'PR', //produkcja
}

export interface Configuration {
  baseApiUrl?: string;
  schemApiUrl: string;
  docsApiUrl: string;
  docsFilesUrl: string;
  publicKeyFileInfoUrl: string;
  publicKeyFilePemUrl: string;
  publicKeyFileDerUrl: string;
  ksefMoreInfoUrl: string;
  openapi: string;
  onlineDoc: string;
  integratorGuide: string;
  overviewOfKey: string;
  netLibrary: string;
  javaLibrary: string;
  environmentAPI: string;
  schemaFA3Url: string;
  crlList: string;
  contactUs: string;
  supportedLangs: string[];
  applicationMode: ApplicationMode;
}

@Injectable({
  providedIn: 'root',
})
export class AppConfigService implements Configuration {
  get baseApiUrl(): string {
    return this.config.baseApiUrl ?? window.location.href.replace(/\/$/, '');
  }

  get schemApiUrl(): string {
    return this.config.schemApiUrl;
  }

  get docsApiUrl(): string {
    return this.config.docsApiUrl;
  }

  get docsFilesUrl(): string {
    return this.config.docsFilesUrl;
  }

  get publicKeyFileInfoUrl(): string {
    return this.config.publicKeyFileInfoUrl;
  }

  get publicKeyFilePemUrl(): string {
    return this.config.publicKeyFilePemUrl;
  }

  get publicKeyFileDerUrl(): string {
    return this.config.publicKeyFileDerUrl;
  }

  get ksefMoreInfoUrl(): string {
    return this.config.ksefMoreInfoUrl;
  }

  get openapi(): string {
    return this.config.openapi;
  }

  get onlineDoc(): string {
    return this.config.onlineDoc;
  }

  get integratorGuide(): string {
    return this.config.integratorGuide;
  }

  get overviewOfKey(): string {
    return this.config.overviewOfKey;
  }

  get netLibrary(): string {
    return this.config.netLibrary;
  }

  get javaLibrary(): string {
    return this.config.javaLibrary;
  }

  get environmentAPI(): string {
    return this.config.environmentAPI;
  }

  get schemaFA3Url(): string {
    return this.config.schemaFA3Url;
  }

  get crlList(): string {
    return this.config.crlList;
  }

  get contactUs(): string {
    return this.config.contactUs;
  }

  get supportedLangs(): string[] {
    return this.config.supportedLangs;
  }

  get applicationMode(): ApplicationMode {
    return this.config.applicationMode;
  }

  private readonly configPath = './assets/config.json';
  private config: Configuration;

  constructor(@Inject(HttpClient) private httpClient: HttpClient) {}

  loadConfiguration(): Promise<void> {
    return this.httpClient
      .get<Configuration>(this.configPath, {
        headers: {
          'Cache-Control': 'no-cache',
          Pragma: 'no-cache',
        },
      })
      .toPromise()
      .then((c: Configuration) => {
        this.config = c;
      });
  }
}
